export const GET_PROMOTIONAL_SIGNUP_CONTENT_REQUEST = 'GET_PROMOTIONAL_SIGNUP_CONTENT_REQUEST';
export const GET_PROMOTIONAL_SIGNUP_CONTENT_SUCCESS = 'GET_PROMOTIONAL_SIGNUP_CONTENT_SUCCESS';
export const GET_PROMOTIONAL_SIGNUP_CONTENT_ERROR = 'GET_PROMOTIONAL_SIGNUP_CONTENT_ERROR';
